import { UserData } from "./assets/DummyData/userData";
import { LOCAL_USER_GENDER } from "./utils";

export const BASE_URL = "https://datingapi.meander.software";

